<template>
  <div class="page">
    <div class="centered-box locations-white locations-generic groups-panel">
      <div class="row">
        <div class="col">
          <div class="groups-title">BOOK A GROUP</div>
          <p class="groups-intro">
            From summer camps to high school class trips, and from church outings
            to scout adventures, we can accommodate—and guide—large-group events
            at any of our four locations. Monday to Friday (no weekends).
          </p>
          <section class="groups-section">
            <h2>Guided group rates</h2>
            <ul>
              <li>
                Paddlers 8th grade or below: $12 per person in a canoe; $25 per
                person in a kayak.
              </li>
              <li>
                Paddlers 9th grade or above: $15 per person in a canoe; $30 per
                person in a kayak.
              </li>
              <li>
                We require one adult chaperone per ten paddlers under 18 years of
                age.
              </li>
              <li>Minimum rate of $300.</li>
            </ul>
          </section>
          <section class="groups-section">
            <h2>Unguided groups</h2>
            <ul>
              <!-- <li>
                20 percent discount on standard hourly rates for unguided group
                events of ten (10) boats or more.
              </li> -->
              <li>
                Must have one adult chaperone per ten (10) paddlers under 18 years of age
              </li>
              <li>
                Parental waiver required for all paddlers under 18 years of age
              </li>
            </ul>
          </section>
          <div class="text-center groups-contact">
            <a class="btn-primary btn" href="#/GroupContact">
              <strong>Contact</strong>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Groups",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  flex-direction: column;
  background-image: url("../assets/groups1.jpg");
}
.page .groups-panel {
  box-sizing: border-box;
  width: min(760px, calc(100vw - 20px));
  max-width: none;
  font-weight: normal;
}
.groups-title {
  margin-bottom: 18px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
}
.groups-intro {
  margin-bottom: 8px;
  line-height: 1.5;
}
.groups-section {
  padding: 12px 0;
  border-bottom: 1px solid #999;
}
.groups-section h2 {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 700;
}
.groups-section ul {
  margin: 0;
  padding-left: 1.25rem;
}
.groups-section li {
  padding: 6px 0;
  line-height: 1.45;
}
.groups-contact {
  display: flex;
  justify-content: center;
  padding-top: 18px;
}
a.btn:hover {
  color: rgb(192, 80, 77);
}
/* ul {
  list-style-type: none;
} */
.note-text {
  color: red;
  margin-top: 20px;
}
a.btn-primary {
  margin: 0;
  text-align: center;
  display: inline-block;
}
</style>
